// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vjepgsqehezzlwctzyge.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZqZXBnc3FlaGV6emx3Y3R6eWdlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ5NzY4ODcsImV4cCI6MjA2MDU1Mjg4N30.knFLEEHAM_QOE5gAvcAPrq9wql79g9DoTmO25GGkVRg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);